module.exports = __webpack_public_path__ + "static/media/image-15.e6cdc773.png";